import { HttpEventType } from "@angular/common/http";
import { Component, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import {
  DigitalesPesv,
  DigitalesPesvService,
} from "../../../../shared/services/digitales-pesv.service";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { AuthService } from "../../../../shared/services/auth.service";
import { DigitalesService } from "../../../../shared/services/digitales.service";
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { PesvService } from "../../../../shared/services/pesv.service";
import { Propietario } from "../../../../shared/model/propietario";
import { PropietarioService } from "../../../../shared/services/propietarios.service";
import { ImplementacionService } from "../../../../shared/services/implementacion.service";
import { VersionesDocumentoService } from "../../../../shared/services/versiones-documento.service";
import { Utils } from "../../../../shared/utils/Utils";
import jsPDF from "jspdf";
import Swal from "sweetalert2";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { GoogleStoragePreviewService } from "../../../../shared/services/google-storage-preview.service";

@Component({
  selector: "app-registrar",
  templateUrl: "./registrar.component.html",
  styleUrls: ["./registrar.component.scss"],
})
export class RegistrarPesvComponent {
  [x: string]: any;
  readonly PUNTO_LIDER = 1;
  readonly FORMATO_LIDER_PESV = 1;

  resultadoPesv: any = null;
  resultadoAdmin: any = null;
  tabActivo: number = 1;

  @ViewChild("modalVistaPreviaDocumento")
  modalVistaPreviaDocumentoTpl!: TemplateRef<any>;

  // Formulario y estado principal
  formPesv!: FormGroup;
  propietario: Propietario | null = null;
  cargando = false;
  usuarioLogin: any;
  liderActivoExistente = false;

  // Adjuntos y configuración
  archivoSoporteSeleccionado: File | null = null;
  empresaNit: string | null = null;
  configuracionDigitalLider: DigitalesPesv | null = null;
  formatosPermitidosLider: string[] = ["pdf"];
  fechaDesignacionMax = this.formatearFechaLocal(new Date());

  // Historial
  cargandoHistorial = false;
  historialLideres: any[] = [];
  filteredHistorialLideres: any[] = [];
  searchTextHistorial = "";
  page1: number = 1;
  pageSize1: number = 10;

  // Vista previa / descarga
  descargandoLiderId: number | null = null;
  documentoVistaPreviaUrl: SafeResourceUrl | null = null;
  documentoVistaPreviaTitulo = "Documento del líder PESV";
  liderDocumentoActual: any = null;
  modalVistaPreviaDocumentoRef: any = null;

  // Subscriptions auxiliares
  private consultaDescargaLiderSub?: Subscription;
  private descargaDocumentoLiderSub?: Subscription;
  private descargaLiderCancelada = false;
  private maestroImplementacion: any = null;
  versionesImplementacion: any[] = [];

  constructor(
    private fb: FormBuilder,
    private propietariosService: PropietarioService,
    private pesvService: PesvService,
    private authService: AuthService,
    private administracionService: AdministracionService,
    private implementacionService: ImplementacionService,
    private versionesDocumentoService: VersionesDocumentoService,
    private digitalesService: DigitalesService,
    private gpcGoogle: gpcGoogleService,
    private digitalesPesvService: DigitalesPesvService,
    private googleStoragePreview: GoogleStoragePreviewService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.usuarioLogin = this.authService.getCurrentUserValue();
    console.log("Usuario logueado:", this.usuarioLogin);
    console.log("Inicializando formulario PESV");
    console.log("Usuario logueado ID:", this.usuarioLogin?.id);
    this.formPesv = this.fb.group({
      cedula: ["", [Validators.required]],
      fecha_designacion: ["", [Validators.required]],
      funcion: ["", [Validators.required]],
      registrado_por: [this.usuarioLogin?.id || ""],
      motivo: [""],
    });

    this.actualizarValidacionFuncion();
    this.configurarValidacionFechas();
    this.cargarNitEmpresa();    
    this.cargarHistorial();
  }

  buscar() {
    this.propietario = null;

    if (this.liderActivoExistente) {
      Swal.fire({
        icon: "warning",
        title: "Líder PESV activo",
        text: "Debes inactivar el líder PESV actual antes de buscar y registrar uno nuevo.",
        confirmButtonText: "Aceptar",
       // confirmButtonColor: "#3085d6",
        allowOutsideClick: false,
        allowEscapeKey: false
    });
      return;
    }

    if (this.formPesv.controls["cedula"].invalid) {
      Swal.fire({
        icon: "warning",
        title: "Campo requerido",
        text: "El número de documento es obligatorio.",
        confirmButtonText: "Aceptar",
       // confirmButtonColor: "#3085d6",
        allowOutsideClick: false,
        allowEscapeKey: false
    });
      
      return;
    }

    const cedula = String(this.formPesv.value.cedula).trim();

    if (!cedula) {
      Swal.fire("Advertencia", "El número de documento no puede estar vacío.", "warning");
      return;
    }

    this.cargando = true;
    this.propietariosService.getCedulaPesv(cedula).subscribe({
      next: (res) => {
        this.cargando = false;
        if (res.propietario) {
          this.propietario = res.propietario;
        } else {
          Swal.fire(
            "Aviso",
            res.mensaje || `No se encontró el número de identificación: ${cedula}.`,
            "info",
            
          );
        }
      },
      error: (err) => {
        this.cargando = false;
        if (err.status === 404) {
          Swal.fire(
            "Aviso",
            `No se encontró el número de identificación: ${cedula}.`,
            "info",
          );
        } else {
          Swal.fire(
            "Error",
            "Ocurrió un error al consultar. Revisa la consola.",
            "error",
          );
          console.error(err);
        }
      },
    });
  }

  create() {
    if (!this.propietario) {
      Swal.fire("Error", "No hay propietario cargado para guardar.", "error");
      return;
    }

    if (this.liderActivoExistente) {
      Swal.fire(
        "Líder activo",
        "Primero debes inactivar el líder PESV actual antes de registrar uno nuevo.",
        "warning",
      );
      return;
    }

    this.continueCreate();
  }

  verificarLiderActivo() {
    this.pesvService.getPesv().subscribe(
      (data: any[]) => {
        this.liderActivoExistente = (data || []).some(
          (item) => Number(item?.estado) === 1,
        );
      },
      () => {
        this.liderActivoExistente = false;
      },
    );
  }

  private extraerLideresActivos(res: any): any[] {
    const lista = Array.isArray(res)
      ? res
      : Array.isArray(res?.pesv)
        ? res.pesv
        : Array.isArray(res?.data)
          ? res.data
          : [];

    return lista.filter((item: any) => this.esRegistroActivo(item?.estado));
  }

  private reemplazarLideresActivosYCrear(lideresActivos: any[]): void {
    this.cargando = true;
    const ids = (lideresActivos || [])
      .map((item: any) => Number(item?.id))
      .filter((id: number) => Number.isFinite(id) && id > 0);

    if (!ids.length) {
      this.continueCreate();
      return;
    }

    this.inactivarLideresSecuencial(ids, 0, () => this.continueCreate());
  }

  private inactivarLideresSecuencial(
    ids: number[],
    index: number,
    onDone: () => void,
  ): void {
    if (index >= ids.length) {
      onDone();
      return;
    }

    this.pesvService.getPesvInactivate(String(ids[index])).subscribe({
      next: () => {
        this.inactivarLideresSecuencial(ids, index + 1, onDone);
      },
      error: (err) => {
        this.cargando = false;
        Swal.fire(
          "Error",
          "No se pudo inactivar el líder activo para reemplazarlo.",
          "error",
        );
        console.error("Error inactivando líder activo:", err);
      },
    });
  }

  private continueCreate() {
    // Validar formulario
    const validacion = this.validarFormulario();
    if (!validacion.valido) {
      this.cargando = false;
      Swal.fire("Advertencia", validacion.mensaje, "warning");
      return;
    }

    // Construir datos del líder PESV
    const datos = this.construirDatosLider();

    // Guardar en el backend
    console.log("Datos a guardar para líder PESV:", datos);
    //return;
    this.guardarLider(datos);
  }

  private validarFormulario(): { valido: boolean; mensaje: string } {
    const { fecha_designacion, funcion } = this.formPesv.controls;

    if (fecha_designacion.invalid) {
      return {
        valido: false,
        mensaje: "La fecha de designación es obligatoria.",
      };
    }

    if (!this.archivoSoporteSeleccionado && funcion.invalid) {
      return {
        valido: false,
        mensaje: "Las funciones son obligatorias para guardar.",
      };
    }

    return { valido: true, mensaje: "" };
  }

  private construirDatosLider(): any {
    const cedula = String(this.propietario!.cedula).trim();
    const nombre = this.construirNombreCompleto();
    const cargo = (this.propietario!.cargoData?.cargos ?? "N/A").toUpperCase();
    const funcion = this.archivoSoporteSeleccionado
      ? "DOCUMENTO SOPORTE CARGADO"
      : String(this.formPesv.get("funcion")?.value || "")
          .toUpperCase()
          .trim();
    const tipo_vinculo = this.propietario!.condicionLaboral?.label ?? "N/A";
    const fecharegistro = this.obtenerFechaColombiaSQL();
    const documento = this.archivoSoporteSeleccionado ? 1 : 0;

    return {
      cedula,
      nombre,
      cargo,
      funcion,
      fecha_designacion: this.formPesv.value.fecha_designacion,
      tipo_vinculo,
      documento,
      creado_por: this.usuarioLogin?.email || "Desconocido",
      fecharegistro,
    };
  }

  private construirNombreCompleto(): string {
    return [
      this.propietario!.primernombre,
      this.propietario!.segundonombre,
      this.propietario!.papellidos,
      this.propietario!.seapellidos,
    ]
      .filter((parte) => !!parte)
      .join(" ")
      .toUpperCase()
      .trim();
  }

  private obtenerFechaColombiaSQL(): string {
    const ahora = new Date();
    const opcionesFecha: Intl.DateTimeFormatOptions = {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };

    const fechaFormateada = ahora.toLocaleString("es-CO", opcionesFecha);
    const [fechaParte, horaParte] = fechaFormateada.split(", ");
    const [dia, mes, anio] = fechaParte.split("/");

    return `${anio}-${mes}-${dia} ${horaParte}`;
  }

  private guardarLider(datos: any): void {
    this.pesvService.createPesv(datos).subscribe({
      next: async (res) => {
        this.cargando = false;
        await this.manejarExitoCreacion(res);
      },
      error: (err) => {
        this.cargando = false;
        Swal.fire("Error", "Error al guardar el registro.", "error");
        console.error("Error al crear líder PESV:", err);
      },
    });
  }

  private async manejarExitoCreacion(res: any): Promise<void> {
    console.log("Respuesta de creación de líder PESV:", res);
    Swal.fire(
      "Éxito",
      res.mensaje || "Registro creado exitosamente.",
      "success",
    );

    Swal.fire({
  icon: "success",
  title: "Líder PESV designado",
  text: res.mensaje || "Registro creado exitosamente.",
  confirmButtonText: "Aceptar",
 
  allowOutsideClick: false,
  allowEscapeKey: false
});

    // Subir documento soporte usando la misma estructura de digitales-pesv
    if (this.archivoSoporteSeleccionado) {
      try {
        await this.subirDocumentoSoporteLider(res.pesv?.id);
      } catch (error) {
        console.error("Error subiendo documento soporte del líder:", error);
        Swal.fire(
          "Advertencia",
          "El líder se guardó, pero el documento soporte no se pudo subir.",
          "warning",
        );
      }
    }

    // Descargar documento desde Digitales automáticamente
   // if (res.pesv?.id) {
     // this.exportarPDF(res.pesv.id);
   // }

    // Limpiar formulario y estado
    this.limpiarFormulario();
    this.cargarHistorial();
  }

  private limpiarFormulario(): void {
    this.propietario = null;
    this.formPesv.reset();
    this.archivoSoporteSeleccionado = null;
    this.fechaDesignacionMax = this.formatearFechaLocal(new Date());
    this.actualizarValidacionFuncion();
  }

  private configurarValidacionFechas(): void {
    const fechaDesignacionControl = this.formPesv.get("fecha_designacion");

    fechaDesignacionControl?.valueChanges.subscribe((valor) => {
      this.fechaDesignacionMax = this.formatearFechaLocal(new Date());
    });
  }

  private validarRangoFechas(): { valido: boolean; mensaje: string } {
    const fechaDesignacionValor = this.formPesv.value.fecha_designacion;

    if (!fechaDesignacionValor) {
      return {
        valido: false,
        mensaje: "La fecha de designación es obligatoria.",
      };
    }

    const fechaDesignacion = this.parseFechaInputLocal(fechaDesignacionValor);
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    if (fechaDesignacion > hoy) {
      return {
        valido: false,
        mensaje: "La fecha de designación no puede ser futura.",
      };
    }

    return { valido: true, mensaje: "" };
  }

  private formatearFechaLocal(fecha: Date): string {
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, "0");
    const day = String(fecha.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  private parseFechaInputLocal(valor: string): Date {
    if (!valor || !/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
      return new Date(NaN);
    }

    const [year, month, day] = valor.split("-").map((part) => Number(part));
    return new Date(year, month - 1, day);
  }

  private actualizarValidacionFuncion(): void {
    const control = this.formPesv?.get("funcion");
    if (!control) {
      return;
    }

    if (this.archivoSoporteSeleccionado) {
      control.clearValidators();
      control.disable({ emitEvent: false });
      control.setValue("", { emitEvent: false });
    } else {
      control.enable({ emitEvent: false });
      control.setValidators([Validators.required]);
    }

    control.updateValueAndValidity({ emitEvent: false });
  }

  get acceptDocumentoSoporte(): string {
    if (!this.formatosPermitidosLider.length) {
      return ".pdf";
    }
    return this.formatosPermitidosLider.map((f) => `.${f}`).join(",");
  }

  onFileChange(event: any): void {
    const file: File = event?.target?.files?.[0];
    if (!file) {
      return;
    }

    const extension = file.name.split(".").pop()?.toLowerCase() || "";
    if (!this.formatosPermitidosLider.includes(extension)) {
      const permitidos = this.formatosPermitidosLider
        .map((f) => `.${f}`)
        .join(", ");
      Swal.fire(
        "Formato inválido",
        `Solo se aceptan: ${permitidos}`,
        "warning",
      );
      event.target.value = "";
      this.archivoSoporteSeleccionado = null;
      this.actualizarValidacionFuncion();
      return;
    }

    this.archivoSoporteSeleccionado = file;
    this.actualizarValidacionFuncion();
    event.target.value = "";
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.add("drag-over");
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");
  }

  onDropDocumentoSoporte(event: DragEvent): void {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove("drag-over");

    const file = event.dataTransfer?.files?.[0];
    if (!file) {
      return;
    }

    const extension = file.name.split(".").pop()?.toLowerCase() || "";
    if (!this.formatosPermitidosLider.includes(extension)) {
      const permitidos = this.formatosPermitidosLider
        .map((f) => `.${f}`)
        .join(", ");
      Swal.fire(
        "Formato inválido",
        `Solo se aceptan: ${permitidos}`,
        "warning",
      );
      return;
    }

    this.archivoSoporteSeleccionado = file;
    this.actualizarValidacionFuncion();
    event.dataTransfer?.clearData();
  }

  removeArchivoSoporte(): void {
    this.archivoSoporteSeleccionado = null;
    this.actualizarValidacionFuncion();
  }

  descargarArchivoSoporteSeleccionado(): void {
    if (!this.archivoSoporteSeleccionado) {
      Swal.fire("Info", "No hay archivo cargado para descargar.", "info");
      return;
    }

    const file = this.archivoSoporteSeleccionado;
    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  }

  get formatosPermitidosTexto(): string {
    return this.formatosPermitidosLider.map((f) => `.${f}`).join(", ");
  }

  private esRegistroActivo(estado: any): boolean {
    if (typeof estado === "boolean") {
      return estado;
    }
    if (typeof estado === "number") {
      return estado === 1;
    }
    if (typeof estado === "string") {
      return ["1", "true", "activo", "active", "si", "sí"].includes(
        estado.trim().toLowerCase(),
      );
    }
    return false;
  }

  private cargarNitEmpresa(): void {
    this.administracionService.obtenerTodas().subscribe({
      next: (res: any) => {
        const lista = Array.isArray(res)
          ? res
          : Array.isArray(res?.administraciones)
            ? res.administraciones
            : [];
        this.empresaNit = lista?.[0]?.nit ? String(lista[0].nit) : null;
      },
      error: (err: any) => {
        console.error("Error al cargar NIT de la empresa:", err);
      },
    });
  }


  private construirNombreArchivoDocumentoLider(file: File, liderId: number | null): string {
    const extension = file.name.split(".").pop()?.toLowerCase() || "bin";
    return `ACTA_LIDER_PESV_${liderId || 0}.${extension}`;
  }

  private obtenerCarpetaDigitalLider(): string {
    // ✅ Incluir NIT administrativo en la ruta de descarga
    const nit = this.empresaNit || "nit";
    return `${nit}/pesv/${this.configuracionDigitalLider?.siglas || "LID"}`;
  }

  private obtenerCarpetaCargadosLider(): string {
    return `${this.configuracionDigitalLider?.siglas || "LID"}`;
  }

  private normalizarIndicadorDocumento(valor: any): number {
    return Number(valor) === 1 ? 1 : 0;
  }

  private obtenerExtensionDesdeDescarga(response: any, blob: Blob): string {
    const contentDisposition = String(
      response?.headers?.get?.("Content-Disposition") || "",
    );

    const nombreMatch =
      contentDisposition.match(/filename\*=UTF-8''([^;]+)/i) ||
      contentDisposition.match(/filename="?([^";]+)"?/i);

    if (nombreMatch?.[1]) {
      const nombreDecodificado = decodeURIComponent(nombreMatch[1]);
      const partes = nombreDecodificado.split(".");
      if (partes.length > 1) {
        return partes.pop()!.toLowerCase();
      }
    }

    const mimeType = String(blob?.type || "").toLowerCase();
    if (mimeType.includes("pdf")) {
      return "pdf";
    }
    if (mimeType.includes("wordprocessingml.document")) {
      return "docx";
    }
    if (mimeType.includes("msword")) {
      return "doc";
    }

    return "bin";
  }

  private abrirBlobEnNuevaVentana(blob: Blob, response?: any): void {
    const url = window.URL.createObjectURL(blob);
    const extension = this.obtenerExtensionDesdeDescarga(response, blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `LIDER PESV.${extension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.setTimeout(() => window.URL.revokeObjectURL(url), 5000);
  }

  private abrirVistaPreviaDocumento(blob: Blob, response?: any): void {
    if (!blob || blob.size === 0) {
      Swal.fire(
        "Información",
        "No hay documento digital disponible para visualizar.",
        "info",
      );
      return;
    }

    if (this.modalVistaPreviaDocumentoRef) {
      this.modalVistaPreviaDocumentoRef.close();
      this.modalVistaPreviaDocumentoRef = null;
    }

    const url = window.URL.createObjectURL(blob);
    this.documentoVistaPreviaUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.documentoVistaPreviaTitulo =
      this.obtenerExtensionDesdeDescarga(response, blob) === "pdf"
        ? "Vista previa del documento"
        : "Vista previa del documento del líder PESV";

    this.modalVistaPreviaDocumentoRef = this.modalService.open(
      this.modalVistaPreviaDocumentoTpl,
      {
        centered: true,
        size: "xl",
        scrollable: true,
        backdrop: "static",
      },
    );

    this.modalVistaPreviaDocumentoRef.result.finally(() => {
      this.documentoVistaPreviaUrl = null;
      window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      this.modalVistaPreviaDocumentoRef = null;
    });
  }

  private mostrarCargandoDescargaPdf(
    accion: "visualizar" | "descargar" = "descargar",
  ): void {
    const titulo =
      accion === "visualizar" ? "Visualizando..." : "Descargando...";
    const mensaje =
      accion === "visualizar"
        ? "Por favor espera mientras se abre la vista previa del documento."
        : "Por favor espera mientras se descarga el documento.";

    Swal.fire({
      title: titulo,
      text: mensaje,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      didOpen: () => {
        Swal.showLoading();
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        this.cancelarDescargaLiderPdf();
      }
    });
  }

  private cancelarDescargaLiderPdf(): void {
    this.descargaLiderCancelada = true;
    this.consultaDescargaLiderSub?.unsubscribe();
    this.descargaDocumentoLiderSub?.unsubscribe();
    this.consultaDescargaLiderSub = undefined;
    this.descargaDocumentoLiderSub = undefined;
    this.descargandoLiderId = null;
    Swal.close();
  }

  private descargarDocumentoDesdeFuenteLider(
    liderId: number,
    indicadorDocumento: number,
    onSinDocumento: () => void,
  ): void {
    if (this.descargaLiderCancelada) {
      return;
    }

    const descargarDesdeDigitales = () => {
      if (this.descargaLiderCancelada) {
        return;
      }

      this.descargaDocumentoLiderSub = this.digitalesService
        .descargarDocumento4ConRespuesta(
          this.obtenerCarpetaDigitalLider(),
          this.FORMATO_LIDER_PESV,
          undefined,
          undefined,
          liderId,
        )
        .subscribe({
          next: (response: any) => {
            if (this.descargaLiderCancelada) {
              return;
            }

            const blob: Blob = response?.body || response;
            if (!blob || blob.size === 0) {
              Swal.close();
              this.descargandoLiderId = null;
              onSinDocumento();
              return;
            }

            this.abrirBlobEnNuevaVentana(blob, response);
            Swal.close();
            this.descargandoLiderId = null;
          },
          error: () => {
            if (this.descargaLiderCancelada) {
              return;
            }

            Swal.close();
            this.descargandoLiderId = null;
            onSinDocumento();
          },
        });
    };

    if (indicadorDocumento !== 1) {
      descargarDesdeDigitales();
      return;
    }

    if (!this.empresaNit) {
      descargarDesdeDigitales();
      return;
    }

    this.descargaDocumentoLiderSub = this.digitalesService
      .descargarDocumento4ConRespuesta(
        `${this.empresaNit}/pesv/cargados/${this.obtenerCarpetaCargadosLider()}`,
        this.FORMATO_LIDER_PESV,
        undefined,
        undefined,
        liderId,
      )
      .subscribe({
        next: (response: any) => {
          if (this.descargaLiderCancelada) {
            return;
          }

          const blob: Blob = response?.body || response;
          if (!blob || blob.size === 0) {
            onSinDocumento();
            return;
          }
          this.abrirBlobEnNuevaVentana(blob, response);
          Swal.close();
          this.descargandoLiderId = null;
        },
        error: () => {
          if (this.descargaLiderCancelada) {
            return;
          }

          onSinDocumento();
        },
      });
  }

  private subirDocumentoSoporteLider(liderId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.archivoSoporteSeleccionado) {
        resolve();
        return;
      }


      if (!this.empresaNit) {
        reject(
          new Error(
            "No se pudo obtener el NIT de la empresa para guardar el soporte del líder.",
          ),
        );
        return;
      }

      const nombreCarpeta = `${this.empresaNit}/pesv/documental/acta/lider_pesv`;

      const nombreArchivo = this.construirNombreArchivoDocumentoLider(
        this.archivoSoporteSeleccionado,
        liderId
      );

      console.log("Subiendo archivo soporte del líder:", this.archivoSoporteSeleccionado);
      console.log("Nombre carpeta:", nombreCarpeta);
      console.log("Nombre archivo:", nombreArchivo);
   

      this.digitalesService.subirArchivo(
          this.archivoSoporteSeleccionado,
          liderId,
          nombreCarpeta,
          nombreArchivo,
          "ACTA_LIDER_PESV",
        )
        .subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.Response) {
              resolve();
            }
          },
          error: (err: any) => {
            reject(err);
          },
        });
    });
  }

  addHeader(doc: jsPDF) {
    const pageWidth = 215;
    const marginLeft = 10;
    const marginTop = 12;
    const headerHeight = 18;

    const leftImageWidth = 40;
    const rightImageWidth = 40;
    const centerBoxWidth =
      pageWidth - marginLeft * 2 - leftImageWidth - rightImageWidth;

    doc.setLineWidth(0.3);
    doc.setDrawColor(0);

    // Rectángulos
    doc.rect(marginLeft, marginTop, leftImageWidth, headerHeight);
    doc.rect(
      marginLeft + leftImageWidth,
      marginTop,
      centerBoxWidth,
      headerHeight,
    );
    doc.rect(
      marginLeft + leftImageWidth + centerBoxWidth,
      marginTop,
      rightImageWidth,
      headerHeight,
    );

    // Logos (reemplaza con tus logos en base64)
    const logoBase64 = "data:image/png;base64,...";
    const logo2Base64 = "data:image/png;base64,...";

    //doc.addImage(logoBase64, 'PNG', marginLeft + 2, marginTop + 2, 36, 16);
    // doc.addImage(logo2Base64, 'PNG', marginLeft + leftImageWidth + centerBoxWidth + 2, marginTop + 2, 36, 16);

    // Título
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "ACTA DE NOMBRAMIENTO DEL LIDER DEL PESV",
      marginLeft + leftImageWidth + centerBoxWidth / 2,
      marginTop + 10,
      {
        align: "center",
      },
    );
  }

  addFooter(doc: jsPDF, currentPage: number, totalPages: number) {
    const pageHeight = doc.internal.pageSize.height;
    const now = new Date();
    const fecha = now.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const hora = now.toLocaleTimeString("es-CO", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    const fechaHora = `${fecha} - ${hora}`;
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100);

    doc.textWithLink(
      "Generado desde Admin SEAF – INDESOFT SAS",
      110,
      pageHeight - 12,
      {
         url: "https://indesoftsas.com",
        align: "center",
      },
    );

    doc.text(fechaHora, 10, pageHeight - 5);
    doc.text(`Página ${currentPage} de ${totalPages}`, 205, pageHeight - 5, {
      align: "right",
    });
  }

  exportarPDF(liderOrId: any): void {
    const id = typeof liderOrId === "object" ? liderOrId?.id : liderOrId;
    const idNumerico = Number(id);
    const indicadorDesdeFila =
      typeof liderOrId === "object"
        ? this.normalizarIndicadorDocumento(liderOrId?.documento)
        : null;

    if (!id) {
      Swal.fire("Error", "No se puede descargar sin ID", "error");
      return;
    }

    Swal.fire({
      title: "Confirmar descarga",
      text: "¿Deseas descargar el documento del líder PESV?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Descargar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.descargandoLiderId = Number.isNaN(idNumerico) ? null : idNumerico;
      this.descargaLiderCancelada = false;
      this.mostrarCargandoDescargaPdf("descargar");

      const onSinDocumento = () => {
        Swal.close();

        this.descargandoLiderId = null;

        // ✅ Fallback implementación
        this.descargarDocumentoImplementacion();
      };

      if (indicadorDesdeFila !== null) {
        this.descargarDocumentoDesdeFuenteLider(
          Number(id),
          indicadorDesdeFila,
          onSinDocumento,
        );
        return;
      }

      this.consultaDescargaLiderSub = this.pesvService
        .getPesvBypdf(id)
        .subscribe({
          next: (resp) => {
            if (this.descargaLiderCancelada) {
              return;
            }

            const pesv = resp?.pesv;
            if (!pesv) {
              Swal.close();
              this.descargandoLiderId = null;
              Swal.fire("Información", "Sin datos", "info");
              return;
            }

            const indicadorDocumento = this.normalizarIndicadorDocumento(
              pesv?.documento,
            );
            this.descargarDocumentoDesdeFuenteLider(
              Number(pesv?.id || id),
              indicadorDocumento,
              onSinDocumento,
            );
          },
          error: (err) => {
            if (this.descargaLiderCancelada) {
              return;
            }

            Swal.close();
            this.descargandoLiderId = null;
            console.error("❌ Error al buscar PESV:", err);
            Swal.fire(
              "Error",
              "No se pudo obtener la información del líder PESV.",
              "error",
            );
          },
        });
    });
  }

  visualizarPDF(liderOrId: any): void {
    const id = typeof liderOrId === "object" ? liderOrId?.id : liderOrId;
    const idNumerico = Number(id);
    const indicadorDesdeFila =
      typeof liderOrId === "object"
        ? this.normalizarIndicadorDocumento(liderOrId?.documento)
        : null;

    if (!id) {
      Swal.fire("Error", "No se puede visualizar sin ID", "error");
      return;
    }

    this.liderDocumentoActual = liderOrId;

    Swal.fire({
      title: "Confirmar visualización",
      text: "¿Deseas visualizar el documento del líder PESV?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Visualizar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.descargandoLiderId = Number.isNaN(idNumerico) ? null : idNumerico;
      this.descargaLiderCancelada = false;
      this.mostrarCargandoDescargaPdf("visualizar");

      if (!this.empresaNit) {
        Swal.close();
        Swal.fire(
          "Error",
          "No se pudo obtener el NIT de la empresa para visualizar el documento.",
          "error",
        );
        return;
      }

      const rutaActaLider = `${this.empresaNit}/pesv/documental/acta/lider_pesv/${id}/ACTA_LIDER_PESV_documental.pdf`;
      console.log("Ruta del acta del líder PESV:", rutaActaLider);
      this.gpcGoogle.getSignedUrlFiles(rutaActaLider).subscribe({
        next: (resp) => {
          Swal.close();
          if (!resp?.url) {
            this.descargandoLiderId = null;
            Swal.fire(
              "Error",
              "No se pudo obtener la URL del documento del líder PESV.",
              "error",
            );
            return;
          }

          this.googleStoragePreview.open(resp.url, "Acta líder PESV");
          this.descargandoLiderId = null;
        },
        error: (err) => {
          this.descargandoLiderId = null;
          Swal.close();
          console.error(
            "❌ Error al obtener la URL del documento del líder PESV.",
            err,
          );
          Swal.fire(
            "Error",
            "No se pudo obtener la URL del documento del líder PESV.",
            "error",
          );
        },
      });

    
      

      

    

      
    });
  }

  descargarDocumentoActual(): void {
    if (!this.liderDocumentoActual) {
      Swal.fire(
        "Error",
        "No hay documento seleccionado para descargar.",
        "error",
      );
      return;
    }

    this.exportarPDF(this.liderDocumentoActual);
  }

  descargarDocumentoLider(lider: any): void {
    if (!lider?.id) {
      Swal.fire("Error", "No se puede descargar sin ID", "error");
      return;
    }

    const id = Number(lider.id);
    if (Number.isNaN(id)) {
      Swal.fire("Error", "ID de líder inválido.", "error");
      return;
    }

    this.descargandoLiderId = id;
    this.descargaLiderCancelada = false;

    Swal.fire({
      title: "Descargando...",
      text: "Por favor espera mientras se descarga el documento.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const fileName = `ACTA_LIDER_PESV_${id}.pdf`;
    const urlFirmada = lider?.url || lider?.signedUrl;

    const descargarConUrl = (url: string) => {
      Swal.close();
      this.descargandoLiderId = null;
      this.descargarDesdeUrlFirmada(url, fileName);
    };

    if (urlFirmada) {
      descargarConUrl(urlFirmada);
      return;
    }

    if (!this.empresaNit) {
      Swal.close();
      this.descargandoLiderId = null;
      Swal.fire(
        "Error",
        "No se pudo obtener el NIT de la empresa para descargar el documento.",
        "error",
      );
      return;
    }

    const rutaActaLider = `${this.empresaNit}/pesv/documental/acta/lider_pesv/${id}/ACTA_LIDER_PESV_documental.pdf`;

    this.gpcGoogle.getSignedUrlFiles(rutaActaLider).subscribe({
      next: (resp) => {
        Swal.close();
        if (!resp?.url) {
          this.descargandoLiderId = null;
          Swal.fire(
            "Error",
            "No se pudo obtener la URL firmada del documento.",
            "error",
          );
          return;
        }

        descargarConUrl(resp.url);
      },
      error: (err) => {
        this.descargandoLiderId = null;
        Swal.close();
        console.error(
          "❌ Error al obtener la URL firmada del documento del líder PESV.",
          err,
        );
        Swal.fire(
          "Error",
          "No se pudo obtener la URL firmada del documento.",
          "error",
        );
      },
    });
  }

 

  private descargarDesdeUrlFirmada(url: string, fileName: string): void {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error al descargar archivo: ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        const enlace = document.createElement("a");
        enlace.href = objectUrl;
        enlace.download = fileName;
        enlace.style.display = "none";
        document.body.appendChild(enlace);
        enlace.click();
        document.body.removeChild(enlace);
        window.URL.revokeObjectURL(objectUrl);
      })
      .catch((error) => {
        console.error("Error al descargar URL firmada:", error);
        Swal.fire("Error", "No se pudo descargar el documento.", "error");
      });
  }



  drawDataTable(
    doc: jsPDF,
    data: { label: string; value: string }[],
    x: number,
    y: number,
  ): number {
    const anchoLabel = 35;
    const anchoValue = 60;
    const anchoTotal = anchoLabel + anchoValue;
    const altoFila = 5;

    const altoTotal = data.length * altoFila;
    doc.setDrawColor(0).setLineWidth(0.3);
    doc.rect(x, y, anchoTotal, altoTotal);

    data.forEach((item, i) => {
      const filaY = y + i * altoFila;

      doc.setFillColor(230, 230, 230);
      doc.rect(x, filaY, anchoLabel, altoFila, "F");

      if (i < data.length) {
        doc.line(x, filaY, x + anchoTotal, filaY);
      }

      doc.line(x + anchoLabel, filaY, x + anchoLabel, filaY + altoFila);

      doc.setFontSize(7).setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.text(String(item.label), x + 2, filaY + 3.5);
      doc.setFont("helvetica", "bold");
      doc.text(String(item.value ?? "N/A"), x + anchoLabel + 2, filaY + 3.5);
    });

    return y + altoTotal;
  }

  formatearFecha(fecha: string | Date): string {
    const fechaObj = new Date(fecha);
    const dia = String(fechaObj.getUTCDate()).padStart(2, "0");
    const mes = String(fechaObj.getUTCMonth() + 1).padStart(2, "0");
    const anio = fechaObj.getUTCFullYear();
    return `${dia}-${mes}-${anio}`;
  }

  formatDateTodo(fecha: any): string {
    if (!fecha) return "N/A";

    let day: number | null = null;
    let month: number | null = null;
    let year: number | null = null;

    if (typeof fecha === "string") {
      const texto = fecha.trim();
      const isoMatch = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        year = Number(isoMatch[1]);
        month = Number(isoMatch[2]);
        day = Number(isoMatch[3]);
      } else {
        const slashMatch = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
        if (slashMatch) {
          day = Number(slashMatch[1]);
          month = Number(slashMatch[2]);
          year = Number(slashMatch[3]);
        }
      }
    } else if (fecha instanceof Date) {
      day = fecha.getDate();
      month = fecha.getMonth() + 1;
      year = fecha.getFullYear();
    }

    if (year === null || month === null || day === null) {
      const d = new Date(fecha);
      if (Number.isNaN(d.getTime())) {
        return "N/A";
      }
      day = d.getDate();
      month = d.getMonth() + 1;
      year = d.getFullYear();
    }

    return `${String(day).padStart(2, "0")}/${String(month).padStart(2, "0")}/${year}`;
  }

  formatDateTimeCompleto(fecha: any): string {
    if (!fecha) return "N/A";
    const d = new Date(fecha);
    const fechaStr = `${String(d.getUTCDate()).padStart(2, "0")}/${String(
      d.getUTCMonth() + 1,
    ).padStart(2, "0")}/${d.getUTCFullYear()}`;
    const horaStr = `${String(d.getUTCHours()).padStart(2, "0")}:${String(
      d.getUTCMinutes(),
    ).padStart(2, "0")}:${String(d.getUTCSeconds()).padStart(2, "0")}`;
    return `${fechaStr} ${horaStr}`;
  }

  mostrarAlerta(
    titulo: string,
    mensaje: string,
    tipo: "success" | "info" | "error" | "warning",
  ): void {
    Swal.fire({ icon: tipo, title: titulo, text: mensaje });
  }
  onTabChange(event: any): void {
    this.tabActivo = event.nextId;

    // Cargar historial cuando se cambia al tab 2
   /*  if (this.tabActivo === 2) {
      this.cargarHistorial();
    } */
  }

  cargarHistorial(): void {
  this.cargandoHistorial = true;

  this.pesvService.getPesv().subscribe({
    next: (res) => {
      this.cargandoHistorial = false;

      console.log("Respuesta del historial de líderes PESV:", res);

      this.historialLideres = Array.isArray(res)
        ? res
        : res?.data || [];

      // Validar si existe un líder activo
      this.liderActivoExistente = this.historialLideres.some(
        (lider) => Number(lider.estado) === 1
      );

      // Aplicar filtro inicial
      this.filteredHistorialLideres = [...this.historialLideres];
    },

    error: (err) => {
      this.cargandoHistorial = false;
      this.liderActivoExistente = false;
      this.historialLideres = [];
      this.filteredHistorialLideres = [];

      Swal.fire(
        "Error",
        "Error al cargar el historial de líderes.",
        "error"
      );

      console.error("Error al cargar historial:", err);
    },
  });
}

  aplicarFiltroHistorial(): void {
    const termino = (this.searchTextHistorial || "").toLowerCase().trim();

    if (!termino) {
      this.filteredHistorialLideres = [...this.historialLideres];
      this.page1 = 1;
      return;
    }

    this.filteredHistorialLideres = this.historialLideres.filter((lider) => {
      const estadoTexto = lider?.estado === 1 ? "activo" : "inactivo";
      const valores = [
        lider?.id,
        lider?.cedula,
        lider?.nombre,
        lider?.cargo,
        lider?.creado_por,
        estadoTexto,
      ];

      return valores.some((valor) =>
        String(valor ?? "")
          .toLowerCase()
          .includes(termino),
      );
    });

    this.page1 = 1;
  }

  exportarExcelHistorial(): void {
    Utils.exportVisibleTableToExcel(
      "tblExtractosExport",
      "historial_lideres_pesv",
    );
  }

  exportarPdfHistorial(): void {
    Utils.exportToPDF(
      "tblExtractosExport",
      "historial_lideres_pesv",
      "Historial de Lideres PESV",
    );
  }

  inactivarLider(id: number): void {
    Swal.fire({
      title: "¿Está seguro?",
      text: "El líder PESV será marcado como inactivo",
      icon: "question",
      showCancelButton: true,
     // confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.cargando = true;
        this.pesvService.getPesvInactivate(String(id)).subscribe({
          next: (res) => {
            this.cargando = false;
          
            Swal.fire({
              icon: "success",
              title: "Líder PESV inactivo",
              text: "Líder inactivado correctamente",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#3085d6",
              allowOutsideClick: false,
              allowEscapeKey: false
            });
            this.cargarHistorial(); // Recargar la tabla
           //this.verificarLiderActivo();
          },
          error: (err) => {
            this.cargando = false;
            Swal.fire("Error", "Error al inactivar el líder", "error");
            console.error("Error al inactivar:", err);
          },
        });
      }
    });
  }

  private cargarMaestroImplementacion(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.implementacionService.getAllImplementaciones().subscribe({
        next: (data: any[]) => {
          const maestro = (data || []).find(
            (item: any) =>
              item?.nombre ===
                "ACTA DE NOMBRAMIENTO DEL LIDER O RESPONSABLE DEL PESV" &&
              Number(item?.estado) === 3,
          );

          if (!maestro) {
            reject("No se encontró implementación");
            return;
          }

          this.maestroImplementacion = maestro;

          this.versionesDocumentoService
            .getVersionesByDocumento(maestro.id)
            .subscribe({
              next: (versiones: any[]) => {
                this.versionesImplementacion = (versiones || []).filter(
                  (v: any) => v?.es_vigente === true,
                );

                resolve({
                  maestro,
                  versiones,
                });
              },

              error: (err) => reject(err),
            });
        },

        error: (err) => reject(err),
      });
    });
  }

  private descargarDocumentoImplementacion(
    liderId?: number,
    indicadorDocumento?: number,
  ): void {
    this.descargandoLiderId = liderId ?? 1;

    const descargarImplementacion = () => {
      if (!this.versionesImplementacion?.length) {
        this.descargandoLiderId = null;

        Swal.fire("Información", "No hay versiones disponibles.", "info");

        return;
      }

      const version = this.versionesImplementacion[0];

      const versionId = version?.id || version?.version_id;

      if (!versionId) {
        this.descargandoLiderId = null;

        Swal.fire("Error", "La versión no tiene ID.", "error");

        return;
      }

      this.digitalesService.descargarArchivoPorVersionId(versionId).subscribe({
        next: (response: any) => {
          this.descargandoLiderId = null;

          Swal.close();

          const blob: Blob = response?.body || response;

          if (!blob || blob.size === 0) {
            Swal.fire("Información", "El documento está vacío.", "info");

            return;
          }

          this.abrirBlobEnNuevaVentana(blob, response);
        },

        error: (err) => {
          this.descargandoLiderId = null;

          Swal.close();

          console.error(err);

          Swal.fire("Error", "No se pudo descargar el documento.", "error");
        },
      });
    };

    // ✅ SI TIENE DOCUMENTO CARGADO
    if (liderId && indicadorDocumento === 1 && this.empresaNit) {
      this.digitalesService
        .descargarDocumento4ConRespuesta(
          `${this.empresaNit}/pesv/cargados/${this.obtenerCarpetaCargadosLider()}`,
          this.FORMATO_LIDER_PESV,
          undefined,
          undefined,
          liderId,
        )
        .subscribe({
          next: (response: any) => {
            const blob: Blob = response?.body || response;

            // ✅ Existe documento del líder
            if (blob && blob.size > 0) {
              this.descargandoLiderId = null;

              Swal.close();

              this.abrirBlobEnNuevaVentana(blob, response);

              return;
            }

            // ❌ No existe → implementación
            descargarImplementacion();
          },

          error: () => {
            // ❌ Error → implementación
            descargarImplementacion();
          },
        });

      return;
    }

    // ✅ No tiene documento → implementación
    descargarImplementacion();
  }



  // METODO PARA DESCARGAR EL PDF DE LA ACTA SUBIDAD AL REPO DIGITAL DE LA EMPRESA O SI NO EXISTE DESCARGAR LA IMPLEMENTACION VIGENTE
  // JJAN 02/06/2026
  VerDocumentoLider(lider: any): void {
    if (!lider?.id) {
      Swal.fire("Error", "No se puede visualizar sin ID", "error");
      return;
    }

    this.visualizarPDF(lider);
  }
}
